<template>
  <div style="background-color: #fff;">
    <div class="header">
      <div class="header-title">{{ content.title }}</div>
      <div class="header-time">
        <span>发布时间:{{ content.releaseDate }}</span>
      </div>
    </div>
    <div
      class="content"
      v-html="content.txt"
      v-loading="loading"
      @click="download(content)"
    ></div>
  </div>
</template>

<script>
import axios from "axios"
import qs from "qs"
export default {
  data() {
    return {
      content: "",
      loading: true,
    }
  },
  created() {
    if (
      this.$route.query.channelIds === undefined ||
      this.$route.query.channelIds === null ||
      this.$route.query.channelIds === ""
    ) {
      alert("参数无效；即将返回首页")
      this.$router.push({ path: "/" })
    } else if (
      this.$route.query.id === undefined ||
      this.$route.query.id === null ||
      this.$route.query.id === ""
    ) {
      alert("参数无效；即将返回首页")
      this.$router.push({ path: "/" })
    } else {
      this.getNewDetails(this.$route.query.channelIds, this.$route.query.id)
    }
  },
  methods: {
    getNewDetails(channelIds, id) {
      let data = {}
      data.id = id
      axios
        .post("/api/gateway/03180/09/web/350179", qs.stringify(data))
        .then((response) => {
          this.content = response.data.body
          while (
            response.data.body.txt.indexOf("http://123.182.146.62:32002") != -1
          ) {
            this.content.txt = response.data.body.txt.replace(
              "http://123.182.146.62:32002",
              "/api"
            )
          }
          this.loading = false
        })
        .catch(function(error) {
          // 请求失败处理
          console.log(error)
        })
    },

    // 下载功能
    download(item) {
      console.log(item)
    },
    // getNewDetails(buzType, titleId) {
    //   axios
    //     .post(
    //       "/token/admin/huaxin/index",
    //       qs.stringify({
    //         data: { buzType: buzType, titleId: titleId },
    //         url: "appapi70002.json",
    //       })
    //     )
    //     .then((response) => {
    //       this.content = response.data.result[0]
    //       while (
    //         response.data.result[0].content.indexOf(
    //           "http://121.17.139.38:1080"
    //         ) != -1
    //       ) {
    //         this.content.content = response.data.result[0].content.replace(
    //           "http://121.17.139.38:1080",
    //           "/api"
    //         )
    //       }
    //       this.loading = false
    //     })
    //     .catch(function(error) {
    //       // 请求失败处理
    //       console.log(error)
    //     })
    // },
  },
}
</script>

<style scoped>
.header {
  /* height: 155px; */
  margin: 0 20px;
}
.header-title {
  /* height: 100px; */
  line-height: 50px;
  text-align: center;
  font-size: 25px;
  font-weight: 700;
}
.header-time {
  height: 45px;
  line-height: 45px;
  border-bottom: 3px solid #e9e9e9;
  text-align: right;
}
.header-time span {
  margin-right: 15%;
  font-size: 14px;
  color: #888;
}
.content {
  padding: 10px 20px;
}
.content >>> img {
  margin: 0 0;
  max-width: 100%;
}
</style>
